<template>
    <div class="container">
        <div class="row">
            <div class="col-md-6">
                <h2 v-if="!sent">Send Email</h2> 
            </div>
        </div> 
        <div class="row mt-4" v-if="!sent">
            <form novalidate="novalidate" @submit.prevent="submit"  class="col col-md-12 border-top border-bottom py-4"> 
                <div class="form-group form-row">
                    <div class="col-md-6" style="display:none">
                        <div class="form-row">
                        <label for="to" class="col-md-2 col-form-label">Sender</label> 
                        <div class="col-md-10">
                            <input type="hidden" id="name" required="required" class="form-control"  
                                :class="{'is-invalid': hasToError}"
                                v-model="to"
                                :disabled="this.loading" > 
                            <form-error name="to" :errors="errors"></form-error>
                        </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-row">
                            <label for="bcc" class="col-md-2 col-form-label">To</label> 
                            <div class="col-md-10">
                                <input type="email" id="name" required="required" class="form-control"  
                                    :class="{'is-invalid': hasBccError}"
                                    v-model="bcc"
                                    :disabled="true" > 
                                <form-error name="bcc" :errors="errors"></form-error>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-row">
                        <label for="cc" class="col-md-2 col-form-label">CC</label> 
                        <div class="col-md-10">
                            <input type="email" id="name" required="required" class="form-control"  
                                :class="{'is-invalid': hasCcError}"
                                v-model="cc"
                                :disabled="this.loading" > 
                            <form-error name="cc" :errors="errors"></form-error>
                        </div>
                        </div>
                    </div>
                </div> 
                <div class="form-group form-row">
                    <div class="col-md-6">
                        <div class="form-row">
                            <label for="subject" class="col-md-2 col-form-label">Subject</label> 
                            <div class="col-md-10">
                                <input type="text" id="name" required="required" autofocus="autofocus" class="form-control"  
                                    :class="{'is-invalid': hasSubjectError}"
                                    v-model="subject"
                                    :disabled="this.loading" > 
                                <form-error name="subject" :errors="errors"></form-error>
                            </div>
                        </div>
                    </div>
                </div>
                <hr/>
                <div class="form-group row">
                    <h4 class="ml-2">Message</h4>
                </div>
                <div class="form-group row">
                    <div class="col-sm-12" :class="{'is-invalid': hasMsgError}">
                        <editor id="tinymce" v-model="message" :init="init" :disabled="this.loading"></editor>
                        <form-error name="message" :errors="errors"></form-error>
                    </div>
                </div> 
                <div class="form-group row">
                    <label for="emailImages" class="col-sm-2 col-form-label">Images</label>
                    <div class=" col-sm-10">
                        <image-upload v-for="(file, index) in uploads" :key="index" v-model="uploads[index]" />

                        <div class="input-group" :class="{'is-invalid': hasImagesError}">
                            <input type="file" class="custom-file-input image-uploader" id="emailImages" name="header_image" 
                                accept="image/jpg,image/png"
                                multiple
                                :class="{'is-invalid': hasImagesError}"
                                :disabled="this.loading" 
                                ref="uploadImageFiles"
                                @change="uploadImage">
                            <label class="custom-file-label" for="emailImages">Choose file</label>
                        </div>
                        <form-error name="images" :errors="errors"></form-error>
                        <small id="emailHelp" class="form-text text-muted">Images will be sent full size at the end of your email. <strong>Max file size 4MB.</strong> All image types accepted (e.g. .jpg, .png)</small>
                    </div>
                </div>

                <div class="form-group row">
                    <div class="col-sm-10">
                        <button type="submit" class="btn btn-primary" v-if="! this.loading">Send</button>
                        <button type="submit"  class="btn btn-primary" disabled v-else>
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            Sending...
                        </button>
                    </div>
                </div> 
            </form>
        </div>
        <div class="row mt-4 justify-content-center" v-else>
            <div class="col-md-8">
                <div class="card">
                    <div class="card-header">Email Sent Successful</div>
                    <div class="card-body">
                        Your email has been sent successfully
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import tinymce from 'tinymce/tinymce';
/* eslint-enable */
import Editor from '@tinymce/tinymce-vue';
import 'tinymce/icons/default';
import 'tinymce/themes/silver';
import 'tinymce/skins/ui/oxide/skin.min.css'
import 'tinymce/skins/ui/oxide/content.min.css'
import 'tinymce/skins/content/default/content.min.css'
import 'tinymce/plugins/table';
import 'tinymce/plugins/image';
import 'tinymce/plugins/autoresize';

import FormError from "../../Util/FormError";
import CurrentUser from "../../../mixins/CurrentUser";
import ImageUpload from "./ImageUpload";

export default {
    data: function () {
        return {
            loading: false,
            sent: false,
            to: '',
            cc: '',
            bcc: '',
            subject: '',
            message: '',
            uploads: [],
            errors: {},
            init: {
                height: 400,
                toolbar: 'undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor removeformat | insertfile image table',
                branding: false,
                menubar: false,
                plugins: 'table image autoresize',
                autoresize_min_height: 400,
                autoresize_max_height: 500,
            }
        }
    },

    components: {
        editor: Editor,
        FormError,
        ImageUpload,
    },

    mixins: [CurrentUser],

    mounted(){
        this.reset();
        this.to = this.currentUser.email;
        this.message = this.currentUser.force.email_template.template;
        
        if (this.$route.query.bcc) {
            this.bcc = this.$route.query.bcc;
        }
    },

    methods: {
        uploadImage: function () {
            this.$refs.uploadImageFiles.files.forEach(item => {
                this.uploads.push({
                    file: item,
                    id: null,
                });
            });
        },

        submit: function () {
            this.loading = true;
            this.errors = {};
            window.axios.post('email/send', this.formData())
                .then(({data}) => this.success(data))
                .catch(({response}) => this.failed(response));
        },

        formData: function () {
            return {
                to: this.to,
                cc: this.cc,
                bcc: this.bcc,
                subject: this.subject,
                message: this.message,
                images: this.images,
            };
        },

        success: function () {  
            this.loading = false; 
            this.sent = true;
        },

        failed: function (response) {
            this.loading = false;
            this.errors = response.data.errors;
        },

        reset: function () {
            this.to = this.cc = this.bcc = this.subject = this.message = '';
            this.loading = this.sent = false;
            this.uploads = [];
            this.errors = {};
        },

        hasError: function (key) {
            return (this.errors[key]);
        },
    },

    computed: {
        hasToError: function () { return this.hasError('to') },
        hasCcError: function () { return this.hasError('cc') },
        hasBccError: function () { return this.hasError('bcc') },
        hasSubjectError: function () { return this.hasError('subject') },
        hasMsgError: function () { return this.hasError('message') },
        hasImagesError: function () { return this.hasError('images') },
        images: function () {
            return this.uploads.map(image => image.id);
        }
    }
}
</script>